<template>
	<div class="tw-flex">
		<AppButton
			startIcon="assets/v2/image/icons/plus.svg"
			:label="$t('contacts.new-group')"
			variant="brand"
			size="md"
			@click="redirectToCreate()"
		/>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const redirectToCreate = () => {
	router.push({ name: 'contacts-create-groups' });
};
</script>

<style lang="scss" scoped></style>
